import { RolesStore } from './RolesStore';

export class RolesStoreAll extends RolesStore {
    constructor() {
        super();
    }
}
